import Layout from '../views/layout/layout'

export  default   {
    path: '/operation',
    name: 'operation',
    component: Layout,
    children: [
        {
            path: '/businessTransformation',
            name: 'businessTransformation',
            component:()=>import('../views/board/businessTransformation'),
            meta: {title: '商务转化率',keepAlive:true}
        },
        {
            path: '/marking',
            name: 'marking',
            component:()=>import('../views/board/markingReport'),
            meta: {title: '营销数据',keepAlive:true}
        },
        {
            path: '/areaRate',
            name: 'areaRate',
            component:()=>import('../views/board/areaRate'),
            meta: {title: '全渠道面积占比分析',keepAlive:true}
        },
        {
            path: '/areaRateSaleManager',
            name: 'areaRateSaleManager',
            component:()=>import('../views/board/areaRateSaleManager'),
            meta: {title: '全渠道面积占比分析-营销主管',keepAlive:true}
        },
        {
            path: '/annualComparison',
            name: 'annualComparison',
            component:()=>import('../views/board/resource/annualComparison'),
            meta: {title: '年度资源同期比',keepAlive:true}
        },
        {
            path: '/resource/index',
            name: 'resourceIndex',
            component:()=>import('../views/board/resource/index'),
            meta: {title: '三年业绩对比',keepAlive:true}
        },
        {
            path: '/fullCase/index',
            name: 'fullCaseIndex',
            component:()=>import('../views/board/fullCase/index'),
            meta: {title: '全案材料分析表'}
        },
        {
            path: '/monthComparison',
            name: 'monthComparison',
            component:()=>import('../views/board/resource/monthComparison'),
            meta: {title: '月度资源同期比',keepAlive:true}
        },
        {
            path: '/operation',
            name: 'operationAnalysis',
            component:()=>import('../views/board/operationAnalysis'),
            meta: {title: '运营分析',keepAlive:true}
        },
        {
            path: '/manageOutput',
            name: 'manageOutput',
            component:()=>import('../views/board/manageOutput'),
            meta: {title: '管理业绩报表',keepAlive:true}
        },
        {
            path: '/goalAttainment',
            name: 'goalAttainment',
            component:()=>import('../views/board/goalAttainment/index'),
            meta: {title: '业绩达成数据',keepAlive:true}
        },
        {
            path: '/netPinReport',
            name: 'netPinReport',
            component:()=>import('../views/board/netPinReport'),
            meta: {title: '网销运营分析表',keepAlive:true}
        },
        {
            path: '/operationSaleMan',
            name: 'operationSaleMan',
            component:()=>import('../views/board/operationAnalysisSaleManager'),
            meta: {title: '运营分析营销主管',keepAlive:true}
        },
        {
            path: '/privatePage',
            name: 'privatePage',
            component:()=>import('../views/biz/operation/privatePage'),
            meta: {title: '运营分析跟单销售',keepAlive:true}
        },
        {
            path: '/privatePageDesigner',
            name: 'privatePageDesigner',
            component:()=>import('../views/biz/operation/privatePageDesigner'),
            meta: {title: '运营分析设计师',keepAlive:true}
        },
        {
            path: '/privatePageCM',
            name: 'privatePageCM',
            component:()=>import('../views/biz/operation/privatePageCM'),
            meta: {title: '运营分析客户经理',keepAlive:true}
        },
        {
            path: '/orderTransLogBoard',
            name: 'orderTransLogBoard',
            component:()=>import('../views/board/orderTransLogBoard'),
            meta: {title: '转单履历表',keepAlive:true}
        },
        {
            path: '/constructionDrawingBranchDimension',
            name: 'constructionDrawingBranchDimension',
            component:()=>import('../views/board/constructionDrawingBranchDimension'),
            meta: {title: '图纸管理报表-分公司维度',keepAlive:true}
        },
        {
            path: '/constructionDrawingDesignerDimension',
            name: 'constructionDrawingDesignerDimension',
            component:()=>import('../views/board/constructionDrawingDesignerDimension'),
            meta: {title: '图纸管理报表-设计师维度',keepAlive:true}
        },
        {
            path: '/productDynamicAchieve',
            name: 'productDynamicAchieve',
            component:()=>import('../views/biz/productDynamicAchieve/index'),
            meta: {title: '产品动态达成表',keepAlive:true}
        },
        {
            path: '/productDynamicDetail',
            name: 'productDynamicDetail',
            component:()=>import('../views/biz/productDynamicAchieve/detail'),
            meta: {title: '产品动态达成详情'}
        },
    ]
}
